<template>
  <div class="settings-container">
      <h1>Címkék</h1>
        <div
        v-for="(tagType, ix) of tagTypes"
        :key="tagType.type"
        >
        <a-divider
            v-if="ix !== 0 && ix !== tagTypes.length"
        ></a-divider>
        <TagsEditorComponent 
            :type="tagType.type"
            :title="tagType.title"
        />
        </div>
  </div>
</template>

<script>
import TagsEditorComponent from './TagsEditorComponent.vue';

export default {
    components: {
        TagsEditorComponent
    },


    data() {
        return {
            tagTypes: [
                {
                    type: 'topic',
                    title: 'Témakör címke'
                },
                {
                    type: 'person',
                    title: 'Személy címke'
                },
                {
                    type: 'other',
                    title: 'Egyéb címke'
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>

</style>